export enum TenantFlightSteps {}
export enum TenantHotelSteps {}
export enum TenantPackageSteps {}
export enum TenantFlightsRebookSteps {}
export enum TenantCarSteps {}
export enum TenantActivitySteps {}
